import React, { useState } from 'react';
import CompareImages from '../utils/compareImage';
import ShowEllipseInfo from '../utils/showEllipseInfo';
import { useEffect } from 'react';
function base64ToBlob(base64) {
  const arr = base64.split(',');
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while(n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new Blob([u8arr], {type: mime});
}

function ImageUpload() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [imageUrl2, setImageUrl2] = useState('');
  const [ellipseInfo, setEllipseInfo] = useState(null);
  const [phase, setPhase] = useState(0); //0: アップロード前, 1: 二値化前, 2: アップロード後

  // マウント時に sessionStorage から復元
  useEffect(() => {
    try {
      const stored = sessionStorage.getItem('ellipseInfo');
      const storedImg = sessionStorage.getItem('ellipseImageUrl');
      if (stored) {
        setEllipseInfo(JSON.parse(stored));
        setPhase(2); // 既に二値化・抽出済み状態として扱う
      }
      if (storedImg) {
        setImageUrl(storedImg);
      }
    } catch (e) {
      console.warn('sessionStorage restore failed', e);
    }
  }, []);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    const formData = new FormData();
    formData.append('file', selectedFile);
    setPhase(1); // 二値化前の状態に設定

    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${apiUrl}/binary`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      // 画像データ（base64）とJSON情報を取得
      setImageUrl(`data:image/png;base64,${data.image1}`);
      setImageUrl2(`data:image/png;base64,${data.image2}`);
    } catch (error) {
      console.error('Error:', error);
    }
  };

const handleUpload2 = async (selected) => {
    // 選択された画像のURLとファイル名を決定
    const base64 = selected === 1 ? imageUrl : imageUrl2;
    const filename = selected === 1 ? 'image1.png' : 'image2.png';
    const blob = base64ToBlob(base64);
    const formData = new FormData();
    formData.append('file', blob, filename);
    setPhase(2); // 二値化完了後の状態に設定

    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await fetch(`${apiUrl}/upload`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      setImageUrl(`data:image/png;base64,${data.image}`);
      setEllipseInfo(data.ellipses);
      console.log(data.ellipses);
      try {
        sessionStorage.setItem('ellipseInfo', JSON.stringify(data.ellipses || {}));
        sessionStorage.setItem('ellipseImageUrl', `data:image/png;base64,${data.image}`);
      } catch (e) {
        console.warn('sessionStorage not available', e);
      }
    } catch (error) {
      console.error('Error:', error);
    }
};
// const handleUpload3 = async (ellipse_data) => {
//   const base64 = imageUrl;
//   const formData = new FormData();
//   formData.append(base64,JSON.stringify(ellipse_data));
//   try {
//     const response = await fetch('http://localhost:5000/lineDetect', {
//       method: 'POST',
//       body: formData,
//     });
//     setPhase(3); // 特徴量抽出
//   } catch (error) {
//     console.error('Error:', error);
//   }
// }
// 楕円選択状態
const [checkedEllipse, setCheckedEllipse] = useState([]);
// 初期状態で全てチェックされた状態にする
useEffect(() => {
  if (!ellipseInfo) return;
  // ellipseInfo がオブジェクトであれば key/value の配列にしてセット
  const initialChecked = Object.entries(ellipseInfo).map(([key, value]) => [key, value]);
  setCheckedEllipse(initialChecked);
  try { sessionStorage.setItem('ellipseInfo', JSON.stringify(ellipseInfo || {})); } catch(e){}
}, [ellipseInfo]);

// phase が 0 に戻されたら sessionStorage をクリア
useEffect(() => {
  if (phase === 0) {
    try {
      sessionStorage.removeItem('ellipseInfo');
      sessionStorage.removeItem('ellipseImageUrl');
    } catch (e) {}
  }
}, [phase]);

// 選択した楕円のみを表示ボタン押下時の処理
const handleChecked = async () => {
  // checkedEllipseは [key, value] の配列
  const selectedEllipses = checkedEllipse.map(([key, value]) => value.contour_index);
  const selectedInfos = Object.values(ellipseInfo).filter(
    info => selectedEllipses.includes(info.contour_index)
  );
  try {
    const response = await fetch('http://localhost:5000/checkedEllipse', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ellipses: selectedInfos }),
    });
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    const data = await response.json();
    // 必要に応じてデータを処理
    console.log('サーバーからの応答:', data);
    // 例: 画像更新や楕円情報更新など
    if (data.image) setImageUrl(`data:image/png;base64,${data.image}`);
    //if (data.ellipses) setEllipseInfo(data.ellipses);
  } catch (error) {
    console.error('Error:', error);
  }
}
  return (
    <div className="card-wide form-group w-full">
      <div className="form-group">
        <input
          type="file"
          accept="image/png, image/jpeg"
          onChange={handleFileChange}
          className="form-input"
        />
        <button
          onClick={handleUpload}
          className="btn btn--primary w-full"
        >
          Upload
        </button>
      </div>
        {phase === 1 ? (
          <CompareImages
            imageUrl={imageUrl}
            imageUrl2={imageUrl2}
            onJudge={handleUpload2}
          />
        ) : phase === 2 ? (
              <ShowEllipseInfo
                ellipseInfo={ellipseInfo}
                imageUrl={imageUrl}
                checkedEllipse={checkedEllipse}
                setCheckedEllipse={setCheckedEllipse}
                handleChecked={handleChecked}
                setEllipseInfo={setEllipseInfo}
                setImageUrl={setImageUrl}
              />
          ):(
          <div className="text-subtitle text-center">
            <p>無効な操作</p>
          </div>
          )
        }
    </div>
  );
}

export default ImageUpload;